import { render, staticRenderFns } from "./CamadasEmpresa.vue?vue&type=template&id=552f5b2a&scoped=true&lang=pug"
import script from "./CamadasEmpresa.vue?vue&type=script&lang=js"
export * from "./CamadasEmpresa.vue?vue&type=script&lang=js"
import style0 from "./CamadasEmpresa.vue?vue&type=style&index=0&id=552f5b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552f5b2a",
  null
  
)

export default component.exports